export class OccupationModal {
  OccupationKey: string = '';
  OccupationName: string = '';
  langCode: string = '';
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/occupation/Occupation/Occupation.Modal.ts